const TEST_VOLUME = 0.5;

export const applyParticipantVolume = (
  audioElement: HTMLAudioElement,
  volume: number,
): boolean => {
  const normalizedVolume = Number.isFinite(volume)
    ? Math.min(1, Math.max(0, volume))
    : 1;

  try {
    audioElement.volume = normalizedVolume;
    audioElement.muted = normalizedVolume === 0;
    return Math.abs(audioElement.volume - normalizedVolume) < 0.01;
  } catch {
    return false;
  }
};

export const isIndividualParticipantVolumeSupported = (): boolean => {
  if (typeof document === "undefined") return false;

  const audioElement = document.createElement("audio");
  const originalVolume = audioElement.volume;

  try {
    audioElement.volume = TEST_VOLUME;
    return Math.abs(audioElement.volume - TEST_VOLUME) < 0.01;
  } catch {
    return false;
  } finally {
    try {
      audioElement.volume = originalVolume;
    } catch {
      // Some mobile browsers expose volume as a read-only value.
    }
  }
};
